'use client'

import { Session } from 'next-auth'
import { getCsrfToken, signIn, signOut } from 'next-auth/react'
import { useEffect } from 'react'

interface ImpersonationRedirectProps {
  impersonationCode: string
  session: Session | null
}

export default function ImpersonationRedirect({
  impersonationCode,
  session,
}: ImpersonationRedirectProps) {
  useEffect(() => {
    const startImpersonation = async () => {
      const csrfToken = await getCsrfToken()
      const callbackUrl = '/'

      if (session) {
        await signOut({ redirect: false })
      }

      await signIn(
        'azure-ad-b2c-impersonation',
        {
          callbackUrl: callbackUrl,
          redirect: true,
          csrfToken,
        },
        { impersonation_code: impersonationCode },
      )
    }

    startImpersonation()
  }, [impersonationCode, session])

  return null
}
